import script from "./BannerMessageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerMessageComponent.vue?vue&type=script&setup=true&lang=js"

import "./BannerMessageComponent.vue?vue&type=style&index=0&id=efacd53c&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-efacd53c"]])

export default __exports__